"use client";

import { useEffect, useRef } from "react";
import { playFireWhoosh, setFireRoar } from "@/lib/sounds";

// Drives the wheel-fire audio from the current heat tier: a whoosh + swell when
// the blaze jumps up a tier, and a continuous roar that tracks the tier (and
// stops when it drops to 0 or the screen unmounts).
export function useFireSound(heat: number) {
  const prev = useRef(0);

  useEffect(() => {
    if (heat > prev.current) playFireWhoosh(heat);
    setFireRoar(heat);
    prev.current = heat;
  }, [heat]);

  // Make sure the roar never lingers after leaving the screen.
  useEffect(() => () => setFireRoar(0), []);
}
